export default "__VITE_ASSET__3DXxARR___"